import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const PageHeader = ({ title, description, crumbs = [] }) => (
  <section className="relative overflow-hidden bg-navy-900" data-testid="page-header">
    <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-navy-700/40" aria-hidden="true" />
    <div className="pointer-events-none absolute -bottom-32 left-1/4 h-72 w-72 rounded-full bg-emerald-600/10" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-4 py-14 sm:px-6 sm:py-16 lg:px-8">
      <nav aria-label="Breadcrumb" className="mb-4" data-testid="breadcrumb">
        <ol className="flex flex-wrap items-center gap-1.5 text-xs font-medium text-slate-400">
          <li>
            <Link to="/" className="transition-colors hover:text-white" data-testid="breadcrumb-home">Home</Link>
          </li>
          {crumbs.map((c, i) => (
            <li key={i} className="flex items-center gap-1.5">
              <ChevronRight className="h-3 w-3" aria-hidden="true" />
              {c.to ? (
                <Link to={c.to} className="transition-colors hover:text-white" data-testid={`breadcrumb-${c.label.toLowerCase().replace(/\s+/g, "-")}`}>{c.label}</Link>
              ) : (
                <span className="text-emerald-400" aria-current="page">{c.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
      <h1 className="font-heading text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">{title}</h1>
      {description && <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-300">{description}</p>}
    </div>
  </section>
);
